import Vue from 'vue'
import App from './App.vue'
import store from './store/store'
import vuetify from './plugins/vuetify'
import MMStorybook from '@mammoth_developer/mm-storybook'
import 'vuetify/dist/vuetify.min.css'
import '@mammoth_developer/mm-storybook/dist/style.css'
const mmStorybookOptions = {}
Vue.use(MMStorybook, mmStorybookOptions)
Vue.use(mmStorybookOptions.mmToasts, { vuetify })
Vue.use(mmStorybookOptions.mmBanners)
// plugins/vuetify.js
import Vuetify from 'vuetify'

Vue.use(Vuetify)
export default new Vuetify()

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
